<template lang="pug">
.row
  .centered-content
    h1 Pricing
    h2 Coming soon
    //p We are still figuring this out, if you have any thoughts on this we would love to hear them!
    bw-pricing-table
</template>

<script>
import BwPricingTable from "@/components/chunks/BwPricingTable";
export default {
  components: {
    BwPricingTable
  }
};
</script>

<style lang="stylus" scoped>
.row
  display: flex
  background: white//#f5f7f9
h1
  margin: 0
  padding-top: 50px
  text-align: center
  font-weight: 500
  font-size: 50px
  line-height: 60px
  color: rgba(0,0,0,0.77)
  margin: 25px 0 18px
h2
  color: rgba(0,0,0,0.67)
  text-align: center
  padding-left: 3px
  line-height: 30px
  margin-bottom: 0
  font-size: 20px
  font-weight: 300
p
  text-align: center
</style>
